module.exports = __webpack_public_path__ + "img/fengche.9615b49a.svg";